// AttentionList.js
// Hero card for the teacher home: the "Needs attention" list built by
// buildAttention() (tests closing soon, struggling topics, inactive
// students, grading backlog). Purely presentational — items arrive already
// derived in the shape { tag, title, subtitle, action }.
// See docs/superpowers/specs/2026-09-16-home-redesign.md §4/§5.
import React from "react";

import HomeCard from "../primitives/HomeCard";
import HomeRow from "../primitives/HomeRow";
import HomeSkeleton from "../primitives/HomeSkeleton";
import HomeEmpty from "../primitives/HomeEmpty";

const identity = (s) => s;

const AttentionList = ({
  items = [],
  loading = false,
  onOpenDashboard,
  isDarkMode = false,
  t = identity,
}) => (
  <HomeCard
    title={t("Needs attention")}
    action={{ label: t("Open dashboard"), onPress: onOpenDashboard }}
    hero
    isDarkMode={isDarkMode}
    testID="attention-list"
  >
    {loading ? (
      <HomeSkeleton rows={3} isDarkMode={isDarkMode} testID="attention-list-skeleton" t={t} />
    ) : items.length === 0 ? (
      <HomeEmpty
        text={t("Nothing needs attention right now.")}
        isDarkMode={isDarkMode}
      />
    ) : (
      items.map((item, index) => (
        <HomeRow
          key={`${item.title}-${index}`}
          tag={item.tag}
          title={item.title}
          subtitle={item.subtitle}
          action={item.action}
          isDarkMode={isDarkMode}
          first={index === 0}
          testID={`attention-row-${index}`}
        />
      ))
    )}
  </HomeCard>
);

export default AttentionList;
